import { useState } from "react";
import s from "./SearchBar.module.css";
import { Grid, Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { setSearchedUsers } from "../../../store/slices/userSlice"
// import { loadingUsersPage } from "../../../store/slices/paginationSlice"
// import { searchUser } from "../../../api/users/UsersConfig";
import providersService from "../../../../../../../../api/providers/providersService";
import { agencieSearch } from "../../../../../../../../api/agencies/AgenciesService";
import { useNotificationContext } from "../../../../../../../Notifications/CustomNotifications";

const SearchBar = ({
  setLoading,
  setSearching,
  toSearch,
  setProvidersSearches,
  setAgenciesSearches,
}) => {
  const notification = useNotificationContext;
  const dispatch = useDispatch();
  const [input, setInput] = useState({ razonsocial: "", cuit: 0 });
  const [inputAgencie, setInputAgencie] = useState("");
  const { activeOrganization } = useSelector((state) => state.gamma);

  const handleSearch = (e) => {
    setInput((prev) => ({ ...prev, razonsocial: e.target.value }));
  };

  const handleSearchAgencie = (e) => {
    setInputAgencie(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (toSearch === "proveedor") {
      console.log("entre a proveedor search");
      setLoading(true);
      setSearching(true);
      providersService
        .searchProvider(1, 50, input, dispatch)
        .then((res) => {
          let filterProviders = res.content.filter((p) => p.enabled);
          setProvidersSearches(filterProviders);
        })
        .then(() => setLoading(false));
    } else {
      console.log("entre a agency search");
      setLoading(true);
      setSearching(true);
      agencieSearch(inputAgencie, "SALE_POINT")
        .then((res) => {
          // let filterAgencies = res.content.filter(a => a.status !== 'DISABLED');
          console.log(res);
          setAgenciesSearches(res.content);
        })
        .then(() => setLoading(false))
        .catch((error) => {
          notification.error("Error endpoint", error.message);
        });
    }
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          input.razonsocial === "" && inputAgencie === ""
            ? e.preventDefault()
            : handleSubmit(e);
        }}
      >
        <Grid
          item
          className={s.searchbar}
          sx={{ borderColor: "primary.main", marginTop: "5%" }}
        >
          <TextField
            fullWidth
            type="text"
            placeholder={`Buscar ${toSearch}...`}
            onChange={
              toSearch === "proveedor" ? handleSearch : handleSearchAgencie
            }
            className={s.textfield}
            sx={{ borderColor: "primary.main" }}
          />
          <Button
            disabled={input.razonsocial === "" && inputAgencie === ""}
            variant="contained"
            onClick={handleSubmit}
            className={s.button}
          >
            Buscar
          </Button>
        </Grid>
      </form>
    </>
  );
};

export default SearchBar;
